<!-- Bottom Sheet Container -->
@if (showContainer) {
<div class="bottom-sheet-container">
  <!-- Backdrop -->
  @if (visible) {
  <div class="bottom-sheet-backdrop" [@.disabled]="isDismissingViaDrag" [@backdrop]
    (@backdrop.done)="onAnimationDone($event)" (click)="onBackdropClick()"></div>
  }

  <!-- Sheet -->
  @if (visible) {
  <div class="bottom-sheet max-w-xl" [class.full-height]="fullHeight" [@.disabled]="isDismissingViaDrag" [@sheet]
    (@sheet.done)="onAnimationDone($event)" (click)="onSheetClick($event)"
    role="dialog"
    aria-modal="true"
    [appFocusTrap]="true">
    <!-- Drag Handle -->
    <div class="bottom-sheet-handle"></div>

    <!-- Header -->
    <div class="bottom-sheet-header select-none z-20 !pt-12 lg:!pt-12" (touchstart)="onDragStart($event)"
      (mousedown)="onDragStart($event)">
      <!-- Back Button -->
      @if (backButtonAction) {
      <app-button color="surface" fill="solid" size="small" [iconOnly]="true"
        ariaLabel="Go back" (click)="handleBack()">
        <app-icon name="arrow-back" size="sm"></app-icon>
      </app-button>
      }

      <div class="bottom-sheet-header-text" [class.pl-4]="backButtonAction">
        @if (title) {
        <h2 class="bottom-sheet-title">{{ title }}</h2>
        } @if (description) {
        <p class="bottom-sheet-description">{{ description }}</p>
        }
      </div>

      <!-- Close Button -->
      @if (closeButtonType === 'done') {
      <app-button color="purple" fill="solid" size="small"
        (click)="handleClose()">
        Done
      </app-button>
      } @else {
      <app-icon-button icon="close" size="md" color="danger" [noBackground]="true" [border]="true" [shadow]="true" (click)="handleClose()">
        <app-icon name="close" size="sm" color="danger"></app-icon>
      </app-icon-button>
      }
    </div>

    <div class="px-4">
      <app-wavy-divider class="mb-3"></app-wavy-divider>
    </div>
    <!-- Content -->
    <div class="bottom-sheet-content pad-safe-area-bottom-20">
      <!-- If content is an array of SheetActionItems, display them -->
      @if (isActionItemArray(content)) {
      <app-card padding="none" class="mb-4">
        <div class="divide-y overflow-hidden rounded-lg">
          @for (item of content; track item.label) {
          <div class="flex px-2 py-2 items-center gap-x-4 cursor-pointer hover:bg-[var(--ion-color-light)]"
            (click)="handleItemClick(item)">
            <div>
              <app-icon [name]="item.icon" size="sm" />
            </div>
            <div class="gap-x-2 py-3">
              @if (item.label) {
              <div class="font-semibold">{{ item.label }}</div>
              } @if (item.description) {
              <div class="font-bold">{{ item.description }}</div>
              }
            </div>
          </div>
          }
        </div>
      </app-card>
      } @else {
      <!-- Custom content projection (template) -->
      <ng-container *ngTemplateOutlet="content"></ng-container>
      }

      <!-- Done Button -->
      <!-- <app-wavy-divider class="my-1"></app-wavy-divider> -->
      @if (showDoneButton) {
      <!-- <app-wavy-divider class="my-1"></app-wavy-divider> -->
      <div class="my-3"></div>
      <app-button [color]="doneButtonColor || 'purple'" fill="solid"
        (click)="handleClose()">{{ doneButtonText || "Done" }}</app-button>
      }
    </div>
  </div>
  }
</div>
}